
  import {Component, Prop, Vue} from "vue-property-decorator";
  import {IApp} from "@/interfaces/app.interface";
  import moment from "moment";

  @Component({})
  export default class CarInfoDateTime extends Vue {
    @Prop() value: string;
    @Prop() prop: string;
    @Prop() label: string;

    dateFormat = IApp.DateFormats.ElementDateTimeFormat;

    get viewMode() { return !this.$store.state.auth.userAccess.scCarMk; }

    get pickerOptions() {
      let options: any = {
        ...IApp.DatePickerOptions.Simple,
        shortcuts: [
          { text: 'Сегодня', onClick: (picker) => picker.$emit('pick', moment().startOf('day').toDate()) },
          { text: 'Вчера', onClick: (picker) => picker.$emit('pick', moment().startOf('day').add(-1, 'days').toDate()) },
          { text: 'Завтра', onClick: (picker) => picker.$emit('pick', moment().startOf('day').add(1, 'days').toDate()) },
          { text: 'Конец дня', onClick: (picker) => picker.$emit('pick', moment().endOf('day').toDate()) },
        ]
      };
      if (this.prop === 'dateEnd') {
        options = {
          ...options,
          disabledDate: this.disableDateEnd,
        }
      }
      return options;
    }

    formItemChange(value) {
      this.$emit('input', value);
      this.$emit('formItemChange');
    }

    clearDate() {
      this.formItemChange('');
    }

    disableDateEnd(value) {
      let current = Number(moment(value).format('x'));
      let today = Number(moment().startOf('day').format('x'));

      return current < today;
    }

  }
